/**
 * The complete tag list, frozen by D-17. It lives on the one base slice so a
 * feature that injects endpoints can invalidate across track boundaries — a
 * punch adjustment must be able to invalidate `Timesheet` without the
 * timesheet feature knowing the punch feature exists.
 *
 * Never add a tag here for a single feature's convenience: D-17 froze this
 * list, and a tag no other track can name is a local cache concern.
 */
export const API_TAG_TYPES = [
  'Contract',
  'Site',
  'Zone',
  'User',
  'Membership',
  'Series',
  'Shift',
  'Punch',
  'Session',
  'Task',
  'Exception',
  'Timesheet',
  'Audit',
  'Settings',
  'Context',
] as const;

export type ApiTagType = (typeof API_TAG_TYPES)[number];
